module.exports = __webpack_public_path__ + "img/male-youngchild-head.7c30d6a4.svg";